var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-2" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("b-overlay", { attrs: { show: _vm.is_load } }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c(
              "div",
              {
                staticClass: "card user_avatar_card mt-4",
                staticStyle: { position: "relative" },
              },
              [
                _c("div", { staticClass: "cont_ph" }, [
                  _c("div", [
                    _c("img", {
                      staticClass: "card-img-top",
                      attrs: { src: _vm.user_avatar_edit.real },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-footer" }, [
                  _c(
                    "div",
                    { staticClass: "pr-3 d-flex align-items-center flex-wrap" },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "w-100 btn btn-lg btn-outline-primary waves-effect waves-themed save_user_settings",
                          attrs: { type: "button" },
                          on: { click: _vm.edit_avatar },
                        },
                        [
                          _c("span", { staticClass: "fal fa-check mr-1" }),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t\tРедагувати\n\t\t\t\t\t\t\t\t"
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c(
              "div",
              {
                staticClass:
                  "d-flex flex-column align-items-center justify-content-center p-4",
              },
              [
                parseInt(_vm.user.id) > 0
                  ? _c("picture", [
                      _c("source", {
                        attrs: {
                          srcset: _vm._f("get_image_from_template")(
                            _vm.user_avatar_template,
                            150,
                            150,
                            "webp"
                          ),
                          type: "image/webp",
                        },
                      }),
                      _vm._v(" "),
                      _c("source", {
                        attrs: {
                          srcset: _vm._f("get_image_from_template")(
                            _vm.user_avatar_template,
                            150,
                            150,
                            "png"
                          ),
                          type: "image/png",
                        },
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "rounded-circle shadow-2 img-thumbnail",
                        attrs: {
                          src: _vm._f("get_image_from_template")(
                            _vm.user_avatar_template,
                            150,
                            150,
                            "png"
                          ),
                          alt: "",
                        },
                      }),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("h5", { staticClass: "mb-0 fw-700 text-center mt-3" }, [
                  _vm._v(
                    "\n\t\t\t\t\t\t\t" +
                      _vm._s(this.user.name) +
                      "\n\t\t\t\t\t\t\t"
                  ),
                  _c("small", { staticClass: "text-muted mb-0" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t\t\t" +
                        _vm._s(_vm.user_company) +
                        "\n\t\t\t\t\t\t\t"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("small", { staticClass: "text-muted mb-0" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t\t\t" +
                        _vm._s(this.user.dolznost) +
                        "\n\t\t\t\t\t\t\t"
                    ),
                  ]),
                ]),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("avatar_modal"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex flex-start w-100" }, [
      _c("div", { staticClass: "mr-2 hidden-md-down" }, [
        _c("span", { staticClass: "icon-stack icon-stack-lg" }, [
          _c("i", {
            staticClass:
              "base base-6 icon-stack-3x opacity-100 color-primary-500",
          }),
          _vm._v(" "),
          _c("i", {
            staticClass: "ni ni-notebook icon-stack-1x opacity-100 color-white",
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-fill" }, [
        _c("div", { staticClass: "flex-fill" }, [
          _c("span", { staticClass: "h5" }, [_vm._v("Налаштування аватара")]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }